<template>
  <div>
    <div class="sidenav-container">
      <!-- Sidenav for settings -->
      
      <div class="sidenav">
        <SettingsLayout :active="this.$route.query.stg_menu?(this.$route.query.stg_menu=='Invoice'?'invoice': this.$route.query.stg_menu=='Sales'?'quotation': this.$route.query.stg_menu=='Credit Note'?'creditnote':this.$route.query.stg_menu=='Payments Received'?'paymentreceived':this.$route.query.stg_menu=='Customer Advance'?'customeradvance':this.$route.query.stg_menu=='Customer Deposit'?'customerdeposit': 'customer_statement'):'invoice'"></SettingsLayout>
      </div>

      <div
        class="sidenave-main-content"
        style="padding:0 !important;margin-top:-6px;overflow-y:hidden"
      >
        <InvoicePrint
          v-if="
            $route.query.stg_menu == 'Invoice' ||
              Object.entries($route.query).length == 0
          "
        ></InvoicePrint>
        <QuotationPrint v-if="$route.query.stg_menu == 'Sales'" />
        <CreditNotePrint v-if="$route.query.stg_menu == 'Credit Note'" />
        <CustomerStatementPrint v-if="$route.query.stg_menu == 'Customer Statement'" />
        <PaymentReceiptPrint  v-if="$route.query.stg_menu == 'Payments Received'" />
          <CustomerAdvanceprint  v-if="$route.query.stg_menu == 'Customer Advance'" />
           <CustomerDepositprint  v-if="$route.query.stg_menu == 'Customer Deposit'" />
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/store/index";
import SettingsLayout from "@/components/Layout/SettingsTemplateLayout";
import InvoicePrint from "@/pages/Settings/Invoice/Print";
import QuotationPrint from "@/pages/Settings/Invoice/Quotationprint";
import CreditNotePrint from "@/pages/Settings/Invoice/Creditprint";
import CustomerStatementPrint from "@/pages/Settings/Invoice/Customerprint";
import PaymentReceiptPrint from "@/pages/Settings/Invoice/PaymentReceiptprint";
import CustomerAdvanceprint from "@/pages/Settings/Invoice/CustomerAdvanceprint";
import CustomerDepositprint from "@/pages/Settings/Invoice/Customerdepositprint";

export default {
  components: {
    SettingsLayout,
    InvoicePrint,
    QuotationPrint,
    CreditNotePrint,
    CustomerStatementPrint,
    PaymentReceiptPrint,
    CustomerAdvanceprint,
    CustomerDepositprint
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    // before this route is loaded
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: routeTo.query.stg_menu || "Invoice"
      })
      .then(() => {
        next();
      })
      .catch(() => {});
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: routeTo.query.stg_menu || "Invoice"
      })
      .then(() => {
        next();
      });
  }
};
</script>
